import {ValueObject} from '@s-ui/domain'

export class BuyerTradeDataTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.address
   * @param {String} data.city
   * @param {String} data.email
   * @param {String} data.name
   * @param {String} data.lastName
   * @param {String} data.personalId
   * @param {String} data.phone
   * @param {String} data.professionalActivityCode
   * @param {String} data.zipCode
   */

  static create = ({address, city, email, lastName, name, personalId, phone, professionalActivityCode, zipCode}) => {
    return new BuyerTradeDataTransactionsValueObject({
      address,
      city,
      email,
      lastName,
      name,
      personalId,
      phone,
      professionalActivityCode,
      zipCode
    })
  }
}
